(ns common.schema.entities.survey-reminder.options)

(def reminder-status-options
  [{:key :survey-reminder.status/scheduled
    :label "Scheduled"}
   {:key :survey-reminder.status/sent
    :label "Sent"}
   {:key :survey-reminder.status/skipped
    :label "Skipped"}
   {:key :survey-reminder.status/cancelled
    :label "Cancelled"}])
